import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AbstractService } from '../../../../services/abstract.service';
import { AbstractSearchKeys } from '../../../../models/abstract/abstract-search.model';
import { AbstractSearchResult } from '../../../../models/abstract/abstract-search-result.model';
import { AbstractKappas } from '../../../../models/abstract/abstract-kappas.model';
import { AccountService } from '../../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../../services/alert.service';
import { AuthService } from '../../../../services/auth.service';
import { NoteService } from '../../../../services/note.service';
import { ReportService } from '../../../../services/report.service';
import { Utilities } from '../../../../services/utilities';
import { CommonModule, formatDate } from '@angular/common';
import { isNull } from 'util';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

interface QcWeekStEnd {
  qcweekid: string;
  wkstartdt: Date;
  wkenddt: Date;
}

@Component({
  selector: 'app-print-abstract',
  templateUrl: './print-abstract.component.html',
  styleUrls: ['../abstract-container.component.css', './print-abstract.component.css'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule
  ],
  encapsulation: ViewEncapsulation.None
})


export class PrintAbstractComponent implements OnInit {


  abstractsData: AbstractSearchResult = new AbstractSearchResult();
  abstractSearchKeys: AbstractSearchKeys = new AbstractSearchKeys();
  loadingIndicator: boolean = false;
  isLoadingResults: boolean = true;
  isRateLimitReached: boolean = false;
  dataSource: AbstractKappas[] = [];


  title: string = "Abstracts for Printing";
  listType: string = "";
  isCoderQList: boolean = false;
  absListTitleStart: string = "";
  absDatesTitleStart: string = "";
  absListTitleEnd: string = "";
  absDatesTitleEnd: string = "";
  absCountTitle: string = "";
  qcWeeks: QcWeekStEnd[] = [];
  activeProjectTitle: string = "";
  projectConnectingText: string = "";

  constructor(
    private alertService: AlertService,
    private route: ActivatedRoute,
    private abstractService: AbstractService,
    private accountService: AccountService,
    private authService: AuthService,
    private noteService: NoteService,
    public router: Router,
    private reportService: ReportService,
    private activeRoute: ActivatedRoute,
    private bottomSheet: MatBottomSheet) {

  }

  public ngOnInit(): void {

    //// params defined in app-routing.module.ts: abstract/print/:abproids/:filtopt/:bypro/:inqc/:incodq/:isexcl/:proid/:srtby/:srtdir
    //// abproids = one or more abstract protocol ids (is 0 when passing values for AbstractSearchKeys)
    this.activeRoute.paramMap.subscribe((paramMap) => {
      var abproParam = paramMap.get('abproids');
      var searchkeys = abproParam == "0";
      if (searchkeys) {
        this.abstractSearchKeys = new AbstractSearchKeys();
        this.abstractSearchKeys.odpProjectWorkflowId = this.accountService.GetActiveProject().odpProjectWorkflowId;
        this.abstractSearchKeys.odpUncodedOnly = true;
        this.abstractSearchKeys.abstractFilterType = this.activeRoute.snapshot.params['filtopt'];
        this.abstractSearchKeys.filterByProtocol = this.activeRoute.snapshot.params['bypro'];
        this.abstractSearchKeys.isInReview = this.activeRoute.snapshot.params['inqc'];
        this.abstractSearchKeys.recommendedForReview = this.activeRoute.snapshot.params['incodq'];
        this.abstractSearchKeys.isReportExcluded = this.activeRoute.snapshot.params['isexcl'];
        this.abstractSearchKeys.protocolId = this.activeRoute.snapshot.params['proid'];
        this.abstractSearchKeys.sortColumnName = 'statusDate';
        this.abstractSearchKeys.sortDirection = this.activeRoute.snapshot.params['srtdir'];
        this.abstractSearchKeys.qcWeek = null;
        if (this.activeRoute.snapshot.params['week'] && this.activeRoute.snapshot.params['week'] != 'null') {
          this.abstractSearchKeys.qcWeek = this.activeRoute.snapshot.params['week'];
        }

        if (this.activeRoute.snapshot.params['inqc'] == "true") {
          this.listType = "Reconciliation List ";
          this.isCoderQList = false;
        } else if (this.activeRoute.snapshot.params['incodq'] == "true") {
          this.listType = "QC Coder Question ";
          this.isCoderQList = true;
        }

        this.title = this.listType + this.title;

        this.abstractService.getAbstractsByParamsFullResult(this.abstractSearchKeys).subscribe({
          next: abstractsFull => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.abstractsData = abstractsFull;
          this.dataSource = abstractsFull.abstractResult;

          var minStatDt = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
          var maxStatDt = formatDate(new Date('1900-01-01T00:00:00'), 'yyyy-MM-dd', 'en-US');
          var minQcWeek = "";
          var maxQcWeek = "";

          this.dataSource.forEach((abpro) => {

            /* Trying to get coder notes - doesn't work...*/
            //if (this.isCoderQList) {
            //  this.noteService.getNotesByAbstractProtocolId(abpro.abstractId, this.abstractSearchKeys.protocolId, this.accountService.GetActiveRole())
            //    .subscribe(notes => abpro.notes = notes);
            //};

            var thing = abpro.coderNotes.length;

            var statDt = formatDate(new Date(abpro.statusDate), 'yyyy-MM-dd', 'en-US');
            if (statDt <= minStatDt) { minStatDt = statDt };
            if (statDt >= maxStatDt) { maxStatDt = statDt };

            ///   1b) Get coders on teams for abstracts in QC selection pool
            //var teamID = [0];
            //teamID.push(abpro.coderTeamId);


            //this.accountService.getWestatCoders(teamID).subscribe(westatCodersResult => {
            //  var coders = westatCodersResult;
            //  coders.forEach((coder) => {
            //    if (abpro.coderTeamUsers == null) {
            //      abpro.coderTeamUsers = "";
            //    } else {
            //      abpro.coderTeamUsers += ", ";
            //    };
            //    abpro.coderTeamUsers += coder.firstName + " " + coder.lastName;
            //  });
            //},
            //  error => {
            //    this.alertService.showStickyMessage(
            //      'Westat Coders Load Error',
            //      `Unable to retrieve coders result from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            //      MessageSeverity.error, error);
            //  });

          });


          /// using getQcDates result
          /// find the qc week record where the minStatDt (earliest status date in abs list) is on or between the first and last dates of the qc week
          /// set minQcWeek = the qc week from that record
          /// find the qc week record where the maxStatDt (latest status date in abs list) is on or between the first and last dates of the qc week
          /// set maxQcWeek = the qc week from that record
          /// set display as "QC for Week " + minQcWeek
          /// if minQcWeek is not same as maxQcWeek then also display += " to Week " + maxQcWeek


          this.reportService.getQcWeeksStEndDates().subscribe({
            next: weeksResult => {
            weeksResult.forEach((week) => {
              var stdtstr = week.qcWeekDmy.slice(0, week.qcWeekDmy.indexOf("-"));
              var enddtstr = week.qcWeekDmy.slice(week.qcWeekDmy.indexOf("-") + 1, week.qcWeekDmy.length);
              var stdt = new Date(stdtstr);
              var endt = new Date(enddtstr);
              let qcwk: QcWeekStEnd = {
                qcweekid: week.qcWeek,
                wkstartdt: stdt,
                wkenddt: endt
              };
              this.qcWeeks.push(qcwk);              
            })

            minQcWeek = this.qcWeeks.find(w => formatDate(w.wkstartdt, 'yyyy-MM-dd', 'en-US') <= minStatDt && formatDate(w.wkenddt, 'yyyy-MM-dd', 'en-US') >= minStatDt).qcweekid;
            var minst = formatDate(this.qcWeeks.find(w => formatDate(w.wkstartdt, 'yyyy-MM-dd', 'en-US') <= minStatDt && formatDate(w.wkenddt, 'yyyy-MM-dd', 'en-US') >= minStatDt).wkstartdt, 'yyyy-MM-dd', 'en-US');
            var minend = formatDate(this.qcWeeks.find(w => formatDate(w.wkstartdt, 'yyyy-MM-dd', 'en-US') <= minStatDt && formatDate(w.wkenddt, 'yyyy-MM-dd', 'en-US') >= minStatDt).wkenddt, 'yyyy-MM-dd', 'en-US');

            maxQcWeek = this.qcWeeks.find(w => formatDate(w.wkstartdt, 'yyyy-MM-dd', 'en-US') <= maxStatDt && formatDate(w.wkenddt, 'yyyy-MM-dd', 'en-US') >= maxStatDt).qcweekid;
            var maxst = formatDate(this.qcWeeks.find(w => formatDate(w.wkstartdt, 'yyyy-MM-dd', 'en-US') <= maxStatDt && formatDate(w.wkenddt, 'yyyy-MM-dd', 'en-US') >= maxStatDt).wkstartdt, 'yyyy-MM-dd', 'en-US');
            var maxend = formatDate(this.qcWeeks.find(w => formatDate(w.wkstartdt, 'yyyy-MM-dd', 'en-US') <= maxStatDt && formatDate(w.wkenddt, 'yyyy-MM-dd', 'en-US') >= maxStatDt).wkenddt, 'yyyy-MM-dd', 'en-US');

            this.absListTitleStart += this.listType + "for Week " + minQcWeek ;
            this.absDatesTitleStart += " (" + minst + " - " + minend + ") ";
            if (minQcWeek != maxQcWeek) {              
              this.absListTitleEnd += " to Week " + maxQcWeek ;
              this.absDatesTitleEnd += " (" + maxst + " - " + maxend + ") ";
            };
              this.absCountTitle += this.abstractsData.abstractResult.length + " Abstracts";
              this.projectConnectingText = "in project";
              this.activeProjectTitle = this.accountService.GetActiveProject().projectTitle;
            
          },
            error: (error) => {
              this.alertService.showStickyMessage(
                'QC Weeks Load Error',
                `Unable to retrieve qcdates from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
                MessageSeverity.error, error);
            }});
          
        },
          error: (error) => {
            this.alertService.stopLoadingMessage();
            this.loadingIndicator = false;
            this.alertService.showStickyMessage('Load Error',
              `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
              MessageSeverity.error, error);
          }});

      } else {
        var elsecase = 1;
        //// [Notes:BJL_2024-05-23] TO DO:
        //// else case means abproParam != 0, has one or more abstract protocol ids
        //// parse the param to a list, then get abstracts by id 
      }

    });
  }

}
